import React from 'react';
var BubbleIcon = function BubbleIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7522 26.9693C35.699 20.323 29.1819 10.4906 27.64 8.3811C27.509 8.21407 27.3695 8.05386 27.222 7.9011C26.782 7.4311 25.986 7.5111 25.722 8.0981C25.1684 9.34589 24.5789 10.5774 23.9541 11.7911C22.6181 14.3381 19.956 15.8631 17.403 17.1871L17.289 17.2471H17.29C15.088 18.4181 12.403 18.5901 10.052 17.7601C9.24405 17.4751 8.40205 17.2341 7.63505 17.1221L7.56205 17.1121C7.08905 17.0451 6.65205 17.4521 6.77205 17.9141C7.36705 20.1781 9.30805 24.7291 9.30805 24.7291C9.30805 24.7291 9.62105 29.5751 10.708 34.7851C10.9101 35.7509 11.0592 36.8308 11.168 37.9492C13.8315 39.2623 16.8296 40 20 40C28.5946 40 35.923 34.5788 38.7522 26.9693Z",
    fill: "#27272A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7522 26.9693C35.699 20.323 29.1819 10.4906 27.64 8.3811C27.509 8.21407 27.3695 8.05386 27.222 7.9011C26.782 7.4311 25.986 7.5111 25.722 8.0981C25.1684 9.34589 24.5789 10.5774 23.9541 11.7911C22.6181 14.3381 19.956 15.8631 17.403 17.1871L17.289 17.2471H17.29C15.088 18.4181 12.403 18.5901 10.052 17.7601C9.24405 17.4751 8.40205 17.2341 7.63505 17.1221L7.56205 17.1121C7.08905 17.0451 6.65205 17.4521 6.77205 17.9141C7.36705 20.1781 9.30805 24.7291 9.30805 24.7291C9.30805 24.7291 9.62105 29.5751 10.708 34.7851C10.9101 35.7509 11.0592 36.8308 11.168 37.9492C13.8315 39.2623 16.8296 40 20 40C28.5946 40 35.923 34.5788 38.7522 26.9693Z",
    fill: "url(#paint0_radial_973_3646)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3285 25.9539C29.0185 25.5939 30.0685 23.7939 29.6735 21.9319C29.2775 20.0709 27.5865 18.8529 25.8955 19.2119C24.2045 19.5719 23.1545 21.3719 23.5495 23.2339C23.9455 25.0949 25.6375 26.3139 27.3285 25.9539ZM27.6285 24.0759C28.2675 23.9399 28.6645 23.2589 28.5145 22.5549C28.3645 21.8509 27.7255 21.3909 27.0865 21.5259C26.4465 21.6619 26.0495 22.3429 26.1995 23.0469C26.3495 23.7509 26.9905 24.2119 27.6285 24.0759ZM15.5685 29.2919C16.9185 29.0049 17.7565 27.5629 17.4385 26.0719C17.1215 24.5789 15.7705 23.6019 14.4205 23.8889C13.0705 24.1759 12.2335 25.6189 12.5505 27.1099C12.8675 28.6019 14.2185 29.5799 15.5685 29.2919ZM15.8175 27.7849C16.3275 27.6769 16.6445 27.1319 16.5245 26.5669C16.4045 26.0029 15.8935 25.6339 15.3825 25.7419C14.8725 25.8509 14.5555 26.3959 14.6755 26.9599C14.7955 27.5249 15.3065 27.8939 15.8175 27.7849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75 20C39.75 9.09238 30.9076 0.25 20 0.25C9.09238 0.25 0.25 9.09238 0.25 20C0.25 30.9076 9.09238 39.75 20 39.75C30.9076 39.75 39.75 30.9076 39.75 20Z",
    stroke: "white",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_973_3646",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0003 21.5001) rotate(75.2561) scale(19.6469 18.9999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.588",
    stopColor: "white",
    stopOpacity: "0.07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.25"
  }))));
};
export default BubbleIcon;